// extracted by mini-css-extract-plugin
export default {"preview":"BookingRequest_Form_Email_preview__qJvZb","console":"BookingRequest_Form_Email_console__-2qhu"};